<template>
  <b-card>
    <app-timeline v-if="data && data.length > 0">
      <app-timeline-item
        v-for="item in data"
        :key="item.id"
        :icon="getIcon(item)"
        :variant="getColor(item)"
      >
        <b-row
          b-type="flex"
          b-justify="space-between"
          class="pb-1"
          style="border-bottom: 1px solid #f4f4f4"
        >
          <b-col cols="9">
            <b-row
              b-type="flex"
              b-justify="space-between"
            >
              <b-col
                cols="12"
                sm="4"
                md="3"
              >
                <b-badge
                  pill
                  variant="light-info"
                >
                  {{ item.dataVencimento | formatSmallDate }}
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                sm="4"
                md="3"
              >
                <b>{{ item.unidade.descricao }}</b>
              </b-col>
              <b-col
                cols="12"
                sm="4"
                md="3"
              >
                <b-badge
                  pill
                  variant="light-primary"
                >
                  {{
                    new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(item.valorCobrado)
                  }}
                </b-badge>

                <b-badge variant="light-primary">
                  {{ getSituacao(item) }}
                </b-badge>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="3"
            align="right"
          >
            <router-link :to="'/reservas/view/' + item.id">
              <b-button
                variant="outline-primary"
                class="btn-icon rounded-circle"
                size="lg"
                :to="`/boleto/view/${item.id}`"
              >
                <feather-icon icon="ArrowRightIcon" />
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </app-timeline-item>
    </app-timeline>
  </b-card>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    copy(barcode) {
      navigator.clipboard.writeText(barcode)

      this.$toast.success('Linha digitável copiada')
    },
    getIcon(boleto) {
      return boleto.situacao === 'ABERTO' ? 'AlertTriangleIcon' : 'CheckIcon'
    },
    getColor(boleto) {
      return boleto.situacao === 'ABERTO' ? 'warning' : 'primary'
    },
    getSituacao(boleto) {
      if (boleto.situacao === 'ABERTO') return 'pendente'
      if (boleto.situacao === 'LIQUIDADO') return 'pago'
      return boleto.situacao
    },
  },
}
</script>

<style lang="scss">
.reserva-timeline li:nth-child(odd) {
  border-left: 4px solid darkblue;
  background-color: #f1f1f1;
}

.reserva-timeline li:nth-child(even) {
  border-left: 4px solid lightblue;
  background-color: white;
}

.date-info {
  font-weight: bold;
}
</style>
